import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './App';
import AppInsightsProvider from 'contexts/AppInsightsContext/AppInsightsProvider';
import 'index.css';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
const Startup = () => {
    return (
        <AppInsightsProvider>
            <App />
        </AppInsightsProvider>
    );
};

root.render(<Startup />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
